export const REQUEST_DOCKET_PARTS = 'REQUEST_DOCKET_PARTS'
export const RECEIVE_DOCKET_PARTS = 'RECEIVE_DOCKET_PARTS'
export const REQUEST_HISTORY_DATA = 'REQUEST_HISTORY_DATA'
export const RECEIVE_HISTORY_DATA = 'RECEIVE_HISTORY_DATA'
export const REQUEST_FILTER_HISTORY_DATA = 'REQUEST_FILTER_HISTORY_DATA'
export const SERVICE_ERROR = 'SERVICE_ERROR'
export const RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR'



// WEBPACK FOOTER //
// ./src/redux/actionTypes/historyTypes.js